'use client'

import { useSession } from 'next-auth/react'
import { usePathname, useSearchParams } from 'next/navigation'
import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react'

export default function PostHogProvider({
  children
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { data: session } = useSession()

  useEffect(() => {
    // Get the base URL dynamically (without /ingest)
    const apiHost = window.location.origin

    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
      api_host: `${apiHost}/ingest`,
      person_profiles: 'identified_only'
    })
  }, [])

  // Capture SPA events
  useEffect(() => {
    if (pathname) {
      let url = window.origin + pathname

      if (searchParams.toString()) {
        url = url + '?' + searchParams.toString()
      }

      posthog.capture('$pageview', { $current_url: url })
    }
  }, [pathname, searchParams])

  // Identify user to events
  useEffect(() => {
    if (session?.user) {
      posthog.identify(session.user.email, {
        email: session.user.email,
        name: session.user.name,
        role: session.user.role,
        tenantId: session.user.tenantId
      })
    } else {
      posthog.reset()
    }
  }, [session])

  return <PHProvider client={posthog}>{children}</PHProvider>
}
